Core.MyAccountSupplierInstaller = (function() {
    var $inputState = $(".selectedState");
    var $inputInState = $(".selectedInState");

    var $selectState = $("#dropdownState");
    var $selectInState = $("#dropdownInState");

    var $btnContinue = $("#btnSaveSupplierInstaller");
    var selectDefaultDom = document.querySelector("#dropdownInState option");
    var selectDefaultText = selectDefaultDom && selectDefaultDom.innerText || '';

    var map = null;

    function executeCallback(clb) {
        clb();
    };

    /*


        DATA


     */

    var d = {
        state: '',
        inState: '',

        subscriberList: {
            selectedState: [],
            selectedInState: [],
        },

        set selectedState(state) {
            this.state = state;
            this.selectedInState = '';

            d.subscriberList.selectedState.forEach(executeCallback);
        },

        get selectedState() {
            return this.state;
        },

        set selectedInState(inState) {
            this.inState = inState;

            d.subscriberList.selectedInState.forEach(executeCallback);
        },

        get selectedInState() {
            return this.inState;
        },

        subscribe(name, callback) {
            d.subscriberList[name].push(callback);
        }
    };


    /*


        METHODS


     */

    var m = {
        init: function() {
            this.loadVar();
            this.loadCallback();

            this.updateState();
            this.onStateChange();

            this.updateInState();

            this.updateDetails();

            this.checkBtn();
            this.initMap();
            this.goTo();
            this.initForm();
        },

        loadVar: function() {
            d.selectedState = $inputState.val();
            d.selectedInState = $inputInState.val();
        },

        loadCallback: function() {
            d.subscribe('selectedState', m.updateInState);

            d.subscribe('selectedInState', m.checkBtn);
            d.subscribe('selectedInState', m.updateDetails);
            d.subscribe('selectedInState', m.goTo);
        },

        /*


            STATE


         */

        updateState: function() {
            var selectedState = d.selectedState;

            if (selectedState === '' || selectedState === 'all') {
                return;
            }

            $selectState.data("kendoDropDownList").value(selectedState);
        },

        onStateChange: function() {
            function updateDataState() {
                d.selectedState = $selectState.data("kendoDropDownList").value();
                $inputState.val(d.selectedState);
                $inputInState.val(d.selectedInState);
            };

            $selectState.data("kendoDropDownList").bind("change", updateDataState);
        },


        /*


            IN STATE


         */

        getInStatesList: function() {
            var selectedState = d.selectedState;

            function isInState(item) {
                return item.State
                    ? item.State.toLowerCase() === selectedState.toLowerCase()
                    : false;
            }

            if (selectedState === '' || selectedState === 'all') {
                return [{Name: selectDefaultText, "Id": ""}];
            }


            if (typeof window.DataJson === 'undefined' || typeof window.DataJson.Data === 'undefined') {
                return [{Name: selectDefaultText, "Id": ""}];
            }


            var inStateList = window.DataJson.Data.filter(isInState);
            return [{Name: selectDefaultText, "Id": ""}].concat(inStateList);
        },

        getInState: function() {
            function isSelectedInState(item) {
                return item.Id === d.selectedInState;
            };

            return m.getInStatesList().find(isSelectedInState);
        },

        updateInState: function() {
            var selectedInState = d.selectedInState;
            var itemList = m.getInStatesList();

            $selectInState.kendoDropDownList({
                dataSource: itemList,
                dataTextField: "Name",
                dataValueField: "Id"
            });

            $selectInState.data("kendoDropDownList").value(selectedInState);
            m.onInStateChange();
        },

        onInStateChange: function() {
            function updateDataInState() {
                d.selectedInState = $selectInState.data("kendoDropDownList").value();
                $inputInState.val(d.selectedInState);
            };

            $selectInState.data("kendoDropDownList").bind("change", updateDataInState);
        },



        /*


            BUTTONS


         */

        checkBtn: function() {
            var hasValidInState = (d.selectedInState !== '' && d.selectedState !== '');
            $btnContinue.attr('disabled', !hasValidInState);
        },



        /*


            DETAILS


         */

        updateDetails: function() {
            var $desc = $('.desc');
            var $details = $('.details');
            var item = m.getInState();

            if (!item.AddressLine1) {
                $content = '&nbsp;';
                $desc.show();
                $details.html($content);
                $details.hide();
                return;
            }

            $content = '<h4 class="mb-2 mt-3">' + item.Name + '</h4>'
                        + '<p class="mb-0">' + item.AddressLine1 + '</p>'
                        + '<p class="mb-0">' + item.Suburb + '</p>'
                        + '<p class="mb-0">' + item.State + ', ' + item.Postcode + '</p>'
                        + '<p class="mb-0">Phone: ' + item.Phone + '</p>'
                        + (item.BusinessHours ? '<p class="mt-3">Business Hours: </p> <div class="mt--3">' + item.BusinessHours + '</div>' : '');

            $desc.hide();
            $details.html($content);
            $details.show();
        },

        /*


            MAP


         */

        initMap: function() {
            var $mapCanvas = $("#google-map-canvas");

            if ($mapCanvas.length) {
                var data = (typeof window.DataJson === 'undefined' || typeof window.DataJson.Data === 'undefined')
                    ? []
                    : window.DataJson.Data;

                map = Core.Map($mapCanvas[0]);
                map.init();
                map.plotMarkers(data);
            }
        },

        goTo: function() {
            var item = m.getInState();

            (!item.AddressLine1)
                ? map.setState(d.selectedState)
                : map.goTo(item.Latitude, item.Longitude);
        },

        initForm: function() {
            var $form = $('.myAccountSupplierInstaller form');

            $form.on('submit', function(e) {
                e.preventDefault();
                if ($form.valid()) {
                    $.ajax({
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        type: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            var _$validationMessage = $form.find('.frm-validation-msg');
                            _$validationMessage.hide();

                            if (data.Success) {
                                window.location.href = data.SuccessUrl;
                            }
                            else {
                                _$validationMessage.html('<div class="error-msg">' + data.ErrorMessage + '</div>').show();
                            }
                        },
                        error: function (xhr, ajaxOptions, thrownError) {
                            //todo: do something
                        }
                    });
                }
            });
        },
    };

    return m;
})();
